// Scope names and the pages that stay inside them.

// One SAVE per property: its tree, endpoints, variants and blocks.
export const propertyScope = (propertyId) => `properties:${propertyId}`;

// A property draft stays while moving between the property page and its
// variant pages; any other page leaves it.
export const propertyStaysOn = (propertyId, pathname) =>
  pathname === `/properties/${propertyId}` ||
  pathname.startsWith(`/property/${propertyId}/`);

export function registerDefaultScopeRoutes(store) {
  store.registerScopeRoutes("properties", propertyStaysOn);
}
